import { getCsrfToken } from "../form_helpers";

export function getPrintMappingReports() {
    const allReports = [];

    const fetchPage = async (paginationToken) => {
        const params = new URLSearchParams({ report_type: 'print_mapping' });
        if (paginationToken) {
            params.set('pagination_token', paginationToken);
        }

        const response = await fetch(`/api/reports?${ params.toString() }`, {
            headers: {
                'Accept': 'application/json',
                'X-CSRF-Token': getCsrfToken()
            }
        });

        if (!response.ok) {
            throw new Error('Error fetching print mapping reports. Please try again.');
        }

        const json = await response.json();
        const data = json.data || json;
        const reports = data.reports || [];

        allReports.push(...reports);

        if (data.pagination_token) {
            return fetchPage(data.pagination_token);
        }

        return allReports;
    };

    return fetchPage(null);
}
